import { render, staticRenderFns } from "./AgentWithdrawalRequestView.vue?vue&type=template&id=5863f884&scoped=true&"
import script from "./AgentWithdrawalRequestView.vue?vue&type=script&lang=js&"
export * from "./AgentWithdrawalRequestView.vue?vue&type=script&lang=js&"
import style0 from "./AgentWithdrawalRequestView.vue?vue&type=style&index=0&id=5863f884&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5863f884",
  null
  
)

export default component.exports